import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

import PrivateRoutes from "../Utils/PrivateRoutes";
import PageTitleChanger from "./PageTitleChanger";
import useNavigationBlocker from "../Utils/userNavigationBlocker";
import { useAppSelector } from "../hooks";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "../SharedContextStore/store";
import { Backdrop } from "@mui/material";
import { useChatIntegration } from "../hooks/useChatIntegration";

const qbpFlag = process.env.REACT_APP_ENABLE_QBP;

const redirectToLoginPage = [
  "/find-username",
  // "/set-password",
  "/username-found",
  "/username-sent",
  "/new-forget-username",
  "/forget-username-error",
  "/login-password",
  "/new-forget-password",
  "/new-forget-username-sent-reminder",
  // "/signUp",
  "/signUp-send-msg-detail",
  "/set-password-validate",
  "/set-password-validate-otp",
  "/validate-login",
  "/validate-login-otp",
  "/new-forget-password-otp",
  "/signUp-password-otp",
  "/signUp-send-msg-detail",
  "/signUp-confirm",
  "/reset-password-confirm"
];

const DashBordHomePage = React.lazy(() => import("../Pages/Home/home"));
const AccountSettingPage = React.lazy(() => import("../Pages/accountSetting"));
const Payments = React.lazy(() => import("../Pages/Payments"));
const Network = React.lazy(() => import("../Pages/Network"));
const Appointment = React.lazy(() => import("../Pages/appointment"));
const HelpAndSupport = React.lazy(() => import("../Pages/helpAndSupport"));
const HelpAndSupportRedesign = React.lazy(() => import("../Pages/helpAndSupportRedesign"));
const MyRewards = React.lazy(() => import("../Pages/myRewards"));
const ACPForm = React.lazy(() => import("../Pages/ACPForm"));
const AddNewAccountPage = React.lazy(
  () => import("../Pages/addnewAccount/addnewaccount")
);
const AccountFoundVerificationCode = React.lazy(
  () => import("../Pages/addnewAccount/accountFoundVerificationCode")
);
const AddNewAccountSuccess = React.lazy(
  () => import("../Pages/addnewAccount/addaccountsuccess")
);
const QuickBillPayments = React.lazy(
  () => import("../Pages/quickBillPayments/QuickBillPayments/QuickBillPayments")
);
const DSL_migrator_Appointment = React.lazy(
  ()=> import("../Pages/DSLFiberMigration/appointmentPage/index")
)

const Wifi7Appointment = React.lazy(
  ()=> import("../Pages/accountSetting/shop-experience/routerInstallation/appointmentPage/index")
)

const AgentQBP = React.lazy(() => import("../Pages/agentQuickBillPay"));
// const NonAuthQBP = React.lazy(() => {
//   return qbpFlag === "false"
//     ? import("../Pages/quickBillPayments/NonAuthenticatedQuickBillPay/index")
//     : import("../Pages/quickBillPayments/NonAuthenticatedQuickBillPay/nonAuthQbpOld")
// });

const NonAuthQBP =  React.lazy(
  () => import("../Pages/quickBillPayments/NonAuthenticatedQuickBillPay/index")
);

const PauseService = React.lazy(
  () => import("../Pages/pauseService/PauseService")
);
const LoginPageWithLatestDeisgn = React.lazy(
  () => import("../Pages/LogReg/loginPage")
);
const LoginPageNew = React.lazy(
  () => import("../Pages/LogReg/new-loginpage")
);
const ForgetUserName = React.lazy(
  () => import("../Pages/LogReg/forgetUserName")
);
const ForgetUserNameError = React.lazy(
  () => import("../Pages/LogReg/forgetUserNameError")
);
const ForgotUserNameReminderPage = React.lazy(
  () => import("../Pages/LogReg/ForgotUserNameReminder")
);
const LoginPasswordPage = React.lazy(
  () => import("../Pages/LogReg/ForgotPasswordPhoneNumber")
);
const ForgotPassword = React.lazy(
  () => import("../Pages/LogReg/ForgotPassword")
);
const ForgotPasswordSendMesgDetails = React.lazy(
  () => import("../Pages/LogReg/ForgotPasswordSendLink")
);
const AccountFoundWithEmailNPhone = React.lazy(
  () => import("../Pages/addnewAccount/accountFoundWithEmailNPhone")
);
const ForgotPasswordVerificationCodePage = React.lazy(
  () => import("../Pages/LogReg/ForgotPasswordVerificationCode")
);
const ResetPasswordNewPage = React.lazy(
  () => import("../Pages/LogReg/ResetPasswordNew")
);
const ResetPasswordSuccessPage = React.lazy(
  () => import("../Pages/LogReg/ResetPasswordReminder")
);
const SignUpEmailPage = React.lazy(() => import("../Pages/LogReg/SignUpEmail"));
const SignUpPasswordPage = React.lazy(
  () => import("../Pages/LogReg/SignUpPassword")
);
const SignUpCompleted = React.lazy(() => import("../Pages/LogReg/SignUpAlert"));

const MultipleAccountsRegisterationPage = React.lazy(
  () => import("../Pages/LogReg/MultipleAccountsRegisteration")
);

const RescheduleAppointmentForOthersPlatform = React.lazy(
  () => import("../Pages/rescheduleAppointmentForOthers")
);
const LoginServiceAddressPage = React.lazy(
  () => import("../Pages/LogReg/loginServiceAddress")
);

const LoginServiceEmailPage = React.lazy(
  () => import("../Pages/LogReg/loginServiceEmail")
);
const LoginServiceAddressNoCaptchaPage = React.lazy(
  () => import("../Pages/LogReg/loginServiceAddressNoCaptcha")
);
const LoginServiceAddressError = React.lazy(
  () => import("../Pages/LogReg/loginServiceAddressError")
);
// const ShopExperience = React.lazy(
//   () => import("../Pages/accountSetting/shop-experience")
// );
const ChangePlanForAgent = React.lazy(
  () => import("../Pages/changePlanForAgent/index")
);
const AccountNotFound = React.lazy(
  () => import("../Pages/LogReg/accountNotVerify")
);
const PaymentArrangements = React.lazy(
  () => import("../Pages/paymentArrangements/index")
);
const AgentPaymentArrangement = React.lazy(
  () => import("../Pages/paymentArrangements/non-authPayArrangements")
);

const AgentPaymentArrangementNew = React.lazy(() => import("../Pages/paymentArrangements/nonAuthPaymentArrangementsNew"))
const SendOTP = React.lazy(
  () =>
    import(
      "../Pages/quickBillPayments/NonAuthenticatedQuickBillPay/SendOTP-NonAuth"
    )
);
const VerifyOTP = React.lazy(
  () =>
    import(
      "../Pages/quickBillPayments/NonAuthenticatedQuickBillPay/VerifyOTP-NonAuth"
    )
);
const ShopExperience =React.lazy(
  () => import("../Pages/accountSetting/shop-experience/index")
)

const ChangePlanRequestFailed =React.lazy(
  () => import("../Pages/accountSetting/shop-experience/ShopReviewOrder/ChangePlanFailed")
)
const ChangePlanMoversFailed = React.lazy (
  () => import("../Pages/Movers/MoversReviewOrder/ChangePlanFailed")
)

const ChangeFlowFailed =React.lazy(
  () => import("../Pages/accountSetting/shop-experience/ChangeFlowFailed")
)

const ShopReviewOrder = React.lazy(
  () => import("../Pages/accountSetting/shop-experience/ShopReviewOrder/index")
)
const DSL_ShopReviewOrder = React.lazy(() => import("../Pages/accountSetting/planDetails/DSL-fiberMigration/dsl-shopreview-order"))
const AdminPortal = React.lazy(
  () =>
    import(
      "../Pages/LoginByPassForAdmin"
    )
);

const FindtUserName = React.lazy(
  () => import("../Pages/LogReg/FindUserName/index")
);


const Found = React.lazy(
  () => import("../Pages/LogReg/FindUserName/found")
);

const FindUserConfirmation = React.lazy(
  () => import("../Pages/LogReg/FindUserName/confirmation")
);

const SuspendNonpay = React.lazy(
  () => import("../Pages/interimWallGarden/SuspendNonpay")
);

const VacationSuspend = React.lazy(
  () => import("../Pages/interimWallGarden/VacationSuspend")
);

const QBPIndex = React.lazy(() =>
  import(
    "../Pages/quickBillPayments/NonAuthenticatedQuickBillPay/NonAuthQuickBillPayments/FormQBP/NonAuthQBPIndex"
  ).then((m) => ({ default: m.QBPIndex }))
);
const TransferFiber = React.lazy(
  () => import("../Pages/Movers/TransferFiber")
);
const MoversShopReviewOrder = React.lazy(
  () => import("../Pages/Movers/MoversReviewOrder/index")
);

const ProtectedApp = () => (
  <PersistGate
    loading={
      <Backdrop className="custom-loader-backdrop" open={true}>
        <div className="custom-loader"></div>
      </Backdrop>
    }
    persistor={persistor}
  >
    <PrivateRoutes />
  </PersistGate>
);

const AllRoutes = () => {
  const location = useLocation();
  const { moversEligibleUser } = useAppSelector((state) => state?.brightSpeedUserUtils);
  const isLoggedIn = useAppSelector((state) => !!state?.user?.token);
  const accessToken = useAppSelector((state) => state?.user?.token);
  const headerCustId = useAppSelector((state) => state?.brightspeedToken?.headers?.cid);
  const userCustId = useAppSelector((state) => state?.user?.data?.customerId);
  useChatIntegration({
    isLoggedIn,
    custId: headerCustId || userCustId,
    accessToken,
  });
  useNavigationBlocker();
  const dslfibermigratorflow = process.env.REACT_APP_DSL_Fiber_MIGRATOR_CHANGES === "true" ? true : false;
  const MOVERS_CHANGE = process.env.REACT_APP_MOVERS_CHANGE === "true" ? true : false;

  return (
    <>
    <PageTitleChanger/>
    <Routes>
      <Route element={<ProtectedApp />}>
        {/* private or protected routes be here */}
        <Route element={<ACPForm />} path="/acpform" />
        <Route
          element={<AccountSettingPage />}
          path="/account-settings/:activeTab"
        />
        <Route element={<DashBordHomePage />} path="/home" />
        <Route element={<Payments />} path="/my-bills/:paymentOption" />
        <Route
          element={<QuickBillPayments />}
          path="/my-bills/quick-bill-payments"
        />
        <Route element={<Appointment />} path="/appointments" />
        {process.env.REACT_APP_MY_REWARDS === "true" && (
          <Route element={<MyRewards />} path="/my-rewards" />
        )}
        <Route element={<PauseService />} path="/pause-service" />
        <Route
          element={<Appointment />}
          path="/appointments/current/:orderNumber"
        />
        <Route element={<HelpAndSupport />} path="/help-and-support" />
        {process.env.REACT_APP_ENV !== "production" && (
          <Route element={<HelpAndSupportRedesign />} path="/help-and-support-redesign" />
        )}
        <Route element={<ShopExperience />} path="/update-plan" />
        <Route element={<Network />} path="/network-settings/:networkOptions" />
        <Route element={<AddNewAccountPage />} path="/add-new-account" />
        <Route
          element={<AccountFoundWithEmailNPhone />}
          path="/account-found"
        />
        <Route
          element={<AddNewAccountSuccess />}
          path="/account-successfully-Added"
        />
        <Route
          element={<AccountFoundVerificationCode />}
          path="/account-verification"
        />
        <Route element={<ShopExperience />} path="/shop-exp" />
        <Route element={<ShopReviewOrder />} path="/shop-review-order" />
        {dslfibermigratorflow && <Route element={<DSL_ShopReviewOrder/>} path="/migration-review-order" />}
        <Route element={<ChangePlanRequestFailed />} path="/change-plan-failed" />
        {MOVERS_CHANGE && <Route element={<ChangePlanMoversFailed />} path="/move-change-flow-failed" />}
        <Route element={<ChangeFlowFailed />} path="/error" />
        {dslfibermigratorflow && <Route
        element={<DSL_migrator_Appointment/>}
        path="/migration-appointment"
        />}
        <Route element={<Wifi7Appointment />} path="/router-appointment" />
         {/* changing the route name as per confluence*/}
      {MOVERS_CHANGE && <Route element={<TransferFiber />} path="/moving" />}
      {MOVERS_CHANGE && <Route element={<MoversShopReviewOrder />} path="/moving/review-move-details" />}

      </Route>

      {/* public or un-protected routes be here */}
      {process.env.REACT_APP_NEW_LOGIN==="true" ?
        <Route element={<LoginPageNew />} path="/login" />
        :
        <Route element={<LoginPageWithLatestDeisgn />} path="/login" />
      }

     <Route
        element={<LoginPageNew />}
        path="/invalid-code"
      />
      <Route
        element={<LoginPageNew />}
        path="/code-expired"
      />


      
        {process.env.REACT_APP_NEW_LOGIN === "true" ?
          <Route element={<LoginPageNew />} path="/login-check-for-outage" />
          :
        <Route element={<LoginPageWithLatestDeisgn />} path="/login-check-for-outage" />
      }

      {redirectToLoginPage.map((path) => (
        <Route
          key={path}
          path={path}
          element={<Navigate to="/login" replace />}
        />
      ))}
      <Route element={<ForgetUserName />} path="/new-forget-username" />

      {process.env.REACT_APP_ENABLE_FIND_USERNAME &&
      <> 
      <Route element={<FindtUserName />} path="/find-username" />
      <Route element={<Found />} path="/username-found" />
      <Route element={<FindUserConfirmation />} path="/username-sent" />
      </>
      }
      
      <Route element={<ForgetUserNameError />} path="/forget-username-error" />
      <Route
        element={<ForgotUserNameReminderPage />}
        path="/new-forget-username-sent-reminder"
      />
      <Route element={<LoginPasswordPage />} path="/login-password" />
      <Route element={<ForgotPassword />} path="/new-forget-password" />
      <Route
        element={<ForgotPasswordSendMesgDetails fromRegister={false} />}
        path="/new-forget-password-send-msg-detail"
      />
      <Route
        element={<ForgotPasswordVerificationCodePage fromRegister={false} />}
        path="/new-forget-password-otp"
      />
      <Route
        element={<ForgotPasswordVerificationCodePage fromRegister={true} />}
        path="/signUp-password-otp"
      />
      <Route element={<ResetPasswordNewPage />} path="/new-reset-password" />
      <Route
        element={<ResetPasswordSuccessPage />}
        path="/new-reset-password-confirm"
      />
      {/* <Route element={<SignUpEmailPage />} path="/signUp" /> */}

      <Route
        element={<ForgotPasswordSendMesgDetails fromRegister={true} />}
        path="/signUp-send-msg-detail"
      />
      <Route
        element={<SignUpPasswordPage fromSetPass={false} />}
        path="/signUp-password"
      />
      <Route
        element={<SignUpCompleted fromSetPass={false} />}
        path="/signUp-confirm"
      />

      {/* <Route
        element={<SignUpPasswordPage fromSetPass={true} />}
        path="/set-password"
      /> */}
      <Route
        element={<SignUpCompleted fromSetPass={true} />}
        path="/reset-password-confirm"
      />

      <Route
        element={<RescheduleAppointmentForOthersPlatform />}
        path="/apmt-others"
      />
      <Route element={<PauseService />} path="/pause-service-external" />

      <Route element={<LoginServiceAddressPage />} path="/uni-login" />
      <Route element={<LoginServiceEmailPage />} path="/uni-login-email" />

      <Route
        element={<LoginServiceAddressNoCaptchaPage />}
        path="/uni-login-nocaptcha"
      />

      <Route
        element={<LoginServiceAddressError />}
        path="/uni-login-no-match"
      />
      <Route
        element={
          <ForgotPasswordSendMesgDetails
            fromRegister={true}
            fromValidateLogin={true}
          />
        }
        path="/validate-login"
      />
      <Route
        element={
          <ForgotPasswordVerificationCodePage
            fromRegister={true}
            fromValidateLogin={true}
          />
        }
        path="/validate-login-otp"
      />
      <Route
        element={
          <ForgotPasswordSendMesgDetails
            fromRegister={true}
            fromValidateLogin={true}
            fromFirstTimeSetPass={true}
          />
        }
        path="/set-password-validate"
      />

      <Route
        element={
          <ForgotPasswordVerificationCodePage
            fromRegister={true}
            fromValidateLogin={true}
            fromFirstTimeSetPass={true}
          />
        }
        path="/set-password-validate-otp"
      />

      <Route element={<ChangePlanForAgent />} path="/change-plan" />
      <Route element={<ShopExperience />} path="/shop-exp-agent" />
      {/* changing the route name as per confluence*/}
      {/* {MOVERS_CHANGE && <Route element={<TransferFiber />} path="/moving" />}
      {MOVERS_CHANGE && <Route element={<MoversShopReviewOrder />} path="/moving/review-move-details" />} */}

      {/* <Route element={<LoginPageWithLatestDeisgn />} path="*" /> */}
         {/* public or un-protected routes be here */}
      {process.env.REACT_APP_NEW_LOGIN==="true"?
      <Route element={<LoginPageNew />} path="*" />
      :
      <Route element={<LoginPageWithLatestDeisgn />} path="*" />
      }
      
      <Route element={<AccountNotFound />} path="/unable-to-verify" />

      {process.env.REACT_APP_NONAUTH_QBP_NEW === "true" 
        ? <Route element={<QBPIndex nonAuth={true} />} path="/agent-quick-bill-pay" /> 
        : <Route element={<AgentQBP />} path="/agent-quick-bill-pay" />
      }
      
      {process.env.REACT_APP_NONAUTH_QBP_NEW === "true"
        ? <Route
          element={<AgentPaymentArrangementNew nonAuth={true} />}
          path="/agent-payment-arrangements"
        />
        :<Route
          element={<AgentPaymentArrangement />}
          path="/agent-payment-arrangements"
        />
      }
     
      <Route
        element={<NonAuthQBP flow="NON_AUTH_QBP" />}
        path="/non-auth-quick-bill-pay"
      />
      <Route
        element={<NonAuthQBP flow="NON_AUTH_QBP" />}
        path="/non-auth-quick-bill-pay/time-out"
      />
      <Route
        element={<NonAuthQBP flow="NON_AUTH_QBP" />}
        path="/non-auth-quick-bill-pay/attempt-exceeded"
      />
      <Route
        element={<NonAuthQBP flow="NON_AUTH_QBP" />}
        path="/non-auth-quick-bill-pay/invalid-code"
      />
       <Route
        element={<NonAuthQBP flow="NON_AUTH_PAYMENT_ARRANGEMENTS" />}
        path="/non-auth-payment-arrangement/time-out"
      />
      <Route
        element={<NonAuthQBP flow="NON_AUTH_PAYMENT_ARRANGEMENTS" />}
        path="/non-auth-payment-arrangement/attempt-exceeded"
      />
      <Route
        element={<NonAuthQBP flow="NON_AUTH_PAYMENT_ARRANGEMENTS" />}
        path="/non-auth-payment-arrangement/invalid-code"
      />
      <Route
        element={<NonAuthQBP flow="NON_AUTH_PAYMENT_ARRANGEMENTS" />}
        path="/non-auth-payment-arrangement"
      />
    
      <Route element={<SendOTP />} path="/non-auth-validation" />
      <Route element={<VerifyOTP />} path="/non-auth-verify-otp" />
      {process.env.REACT_APP_ALLOW_ADMIN_ROUTE === "true" && <Route element={<AdminPortal />} path="/login-with-admin" />}
      {process.env.REACT_APP_ENABLE_INTERIM_WALLGARDEN === "true" && 
        <>
          <Route element={<VacationSuspend />} path="/vacation-suspend" />
          <Route element={<SuspendNonpay />} path="/suspend-nonpay" />
        </>
      }
    </Routes>
    </>
  );
};

export default AllRoutes;
